import { faExclamationSquare } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'

export function WithoutPermissionsReports() {
  const { t } = useTranslation()

  return (
    <Tooltip
      title={t('commons.tooltips.withoutPermissionsReports')}
      placement={'right'}
    >
      <FontAwesomeIcon size={'xs'} icon={faExclamationSquare} />
    </Tooltip>
  )
}

export default WithoutPermissionsReports
